import React, { useCallback, useEffect, useState } from "react";

import Container from "@mui/material/Container";
import { useParams } from "react-router-dom";
import ContentEditDialog from "./ContentEditDialog";
import { notBlank } from "../../../util/ext";

const ContentEdit = props => {
  const { onCancel, onSaveSuccess } = props;
  const { id } = useParams();
  const [editVisible, setEditVisible] = useState(false);

  const handleSuccess = useCallback(() => {
    setEditVisible(false);
    onSaveSuccess();
  }, [onSaveSuccess]);

  const handleCancel = useCallback(() => {
    setEditVisible(false);
    onCancel();
  }, [onCancel]);

  useEffect(() => {
    if (notBlank(id)) {
      setEditVisible(true);
    } else {
      setEditVisible(false);
    }
  }, [id]);

  return (
    <Container>
      <ContentEditDialog
        id={id}
        visible={editVisible}
        onCancel={handleCancel}
        onSaveSuccess={handleSuccess}
      />
    </Container>
  );
};

export default ContentEdit;
